import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudOff24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCloudOff24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M18.526 4.418a.75.75 0 0 1 1.056 1.056l-.052.056-.913.912a6.27 6.27 0 0 1 1.802 5.166A4.44 4.44 0 0 1 22 15c0 2.485-2.066 4.5-4.615 4.5H6.615q-.493-.001-.958-.098L4.53 20.53a.75.75 0 1 1-1.06-1.06l15-15zM7.061 18h10.324c1.756 0 3.115-1.379 3.115-3 0-.887-.4-1.692-1.054-2.249l-.611-.52.094-.797a4.79 4.79 0 0 0-1.372-3.93zm6.862-13.5c.737 0 1.445.12 2.106.339l-1.234 1.234A5 5 0 0 0 13.923 6a5.1 5.1 0 0 0-3.31 1.2l-.522.44-.674-.103a3 3 0 0 0-.494-.037c-1.757 0-3.115 1.379-3.115 3q0 .196.025.384l.134 1.015-.897.496C4.117 12.92 3.5 13.9 3.5 15c0 .654.224 1.265.603 1.766l-1.07 1.07A4.4 4.4 0 0 1 2 15c0-1.68.945-3.146 2.346-3.919a4 4 0 0 1-.038-.58c0-2.486 2.066-4.5 4.615-4.5q.368 0 .72.054a6.6 6.6 0 0 1 4.28-1.555"
            />
        </svg>
    );
}
export default memo(IconCloudOff24);
